import {
        Doc,
        DocRef,
        GSTTreatment,
        PlaceOfSupply       }   from    "../../../../common/common.model";
import { Item } from "../invoices/invoice.model";

export class Customer extends Doc {
    public firstName            :   string;
    public lastName             :   string;
    public name                 :   string;
    public email                :   string;
    public companyName          :   string;
    public phone                :   string;
    public openingBalance       :   string;
    public address              :   string;
    public city                 :   string;
    public state                :   string;
    public zipcode              :   string;
    public gstTreatment         :   GSTTreatment;
    public gstin                :   string;
    public placeOfSupply        :   PlaceOfSupply;
    public items                :   Item[]

    constructor(data: any = {}) {
        super(data);
        this.firstName          =   data.firstName      ||  '';
        this.lastName           =   data.lastName       ||  '';
        this.name               =   this.firstName + " " + this.lastName;
        this.email              =   data.email          ||  '';
        this.companyName        =   data.companyName    ||  '';
        this.phone              =   data.phone          ||  '';
        this.openingBalance     =   data.openingBalance ||  '';
        this.address            =   data.address        ||  '';
        this.city               =   data.city           ||  '';
        this.state              =   data.state          ||  '';
        this.zipcode            =   data.zipcode        ||  '';
        this.gstTreatment       =   data.gstTreatment   ||  GSTTreatment.None;
        this.gstin              =   data.gstin          ||  '';
        this.placeOfSupply      =   data.placeOfSupply  ||  PlaceOfSupply.TN;
        if(data.items) {
            this.items              =   data.items.length ? data.items.map((item: Item) => new Item(item)): [];
        } else {
            this.items              =   [];
        }
    }

    public toJson() {
        return {
            ...this,
            items: this.items.map(item => item.toJson())
        };
    }
}

export class CustomerRef extends DocRef {
    public name                 :   string;
    public email                :   string
    public companyName          :   string
    constructor(data: any = {}) {
        super(data);
        this.name               =   data.name   ||  '';
        this.email              =   data.email  ||  '';
        this.companyName        =   data.companyName || '';
    }

    public toJson(): any {
        return {
            ...this
        };
    }
}